module.exports = __webpack_public_path__ + "img/usersIcon_Inactive.2fe87bb6.png";